import Flags from 'country-flag-icons/react/3x2';
import { FC } from 'react';

import './index.scss';

type CountryFlagProps = {
	country: any;
};

const flags = Flags as any;

export const CountryFlag: FC<CountryFlagProps> = ({ country }) => {
	const Flag = flags[country];
	return (
		<div className="flag">
			<Flag className="flag__icon" />
		</div>
	);
};
